<div class="row">
    <div class="col-12">
        <h4>{{ mode === 'pick' ? 'Pluk' : 'Pak' }} plukliste</h4>
    </div>
    <div class="col-6">
        <form (ngSubmit)="getPickingList()" *ngIf="!pickingList">
            <div class="d-flex gap-1 align-items-end">
                <div>
                    <label class="form-label">Søg:</label>
                    <input type="text" placeholder="Plukliste Nr" name="id" class="form-control"
                           [(ngModel)]="search.id" #yourInput
                    >
                </div>
                <button type="submit" class="btn btn-secondary">Søg</button>
            </div>
        </form>

        <ngb-alert [dismissible]="false" *ngIf="alert" [type]="alertType" class="mt-3">
            {{ alert }}
        </ngb-alert>

        <ng-container *ngIf="pickingList">
            <dl>
                <dt>Plukliste Nr:</dt>
                <dd>{{ pickingList.id }}</dd>
                <dt>Oprettet:</dt>
                <dd>{{ pickingList.created.format('YYYY-MM-DD HH:mm:ss') }}</dd>

                <dt>Forsendelser:</dt>
                <dd>
                    <a href="javascript:void(0)" (click)="showShipmentsModal(pickingList)">
                        {{ pickingList.shipments.length }} forsendelser
                    </a>
                </dd>
                <!-- <dt>Pluk start</dt>
                 <dd>
                     <app-picking-list-status [pickingList]="pickingList"
                                              [event]="'picking_started'"></app-picking-list-status>
                 </dd>

                 <dt>Pluk stop</dt>
                 <dd>
                     <app-picking-list-status [pickingList]="pickingList"
                                              [event]="'picking_completed'"></app-picking-list-status>
                 </dd>
                 <dt>Pak start</dt>
                 <dd>
                     <app-picking-list-status [pickingList]="pickingList"
                                              [event]="'packing_started'"></app-picking-list-status>
                 </dd>
                 <dt>Pak stop</dt>
                 <dd>
                     <app-picking-list-status [pickingList]="pickingList"
                                              [event]="'packing_completed'"></app-picking-list-status>
                 </dd>-->
            </dl>
            <a href="javascript:void(0)" class="btn btn-link" (click)="reset()">Nulstil</a>
        </ng-container>

    </div>
    <div class="col-6">
        <ng-container *ngIf="pickingList">
            <div class="d-flex gap-2 align-items-start">
                <app-spinner *ngIf="loading"></app-spinner>
                <ng-container *ngIf="!loading">
                    <div>
                        <label class="form-label">Initialer</label>
                        <input type="text" placeholder="Initialer" name="initials" class="form-control"
                               autocomplete="off"
                               [(ngModel)]="search.initials"
                               #initialsInput
                               (keydown.enter)="initialsInput.blur()"
                        >
                    </div>

                    <div>
                        <label class="form-label">Handling</label>
                        <div class="d-flex gap-1">
                            <ng-container *ngIf="mode ==='pick'">
                                <button type="submit" class="btn btn-success" [disabled]="
                                pickingList?.status_map['picking_started'] ||
                                !search.initials"
                                        (click)="sendEvent('picking_started')">Start
                                    Plukning
                                </button>
                                <button type="submit" class="btn btn-danger" [disabled]="
                                !pickingList?.status_map['picking_started'] ||
                                                             pickingList?.status_map['picking_completed'] ||
!search.initials"
                                        (click)="sendEvent('picking_completed')">Stop/Afslut
                                    Plukning
                                </button>
                            </ng-container>

                            <ng-container *ngIf="mode ==='pack'">
                                <button type="submit" class="btn btn-success" [disabled]="

                                                                !pickingList?.status_map['picking_completed'] ||
                                                                pickingList?.status_map['packing_started'] ||

!search.initials"
                                        (click)="sendEvent('packing_started')">Start
                                    Pakning

                                </button>
                                <button type="submit" class="btn btn-danger" [disabled]="
                                 !pickingList?.status_map['packing_started'] ||
                                                             pickingList?.status_map['packing_completed'] ||
                                                             !search.initials"
                                        (click)="sendEvent('packing_completed')">Stop/Afslut
                                    Pakning
                                </button>
                            </ng-container>

                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</div>

